import React, { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import styles from './UIGameBeginnerHint.module.scss';
import { T, Tooltip } from '@colonist/ui';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { getBeginnerHintContent } from './utils.ts';
import IconBeginnerHint from '@static/images/icon_beginner_hint.svg';
import { CardEnum } from '@colonist/game-states';
import { EnumUtils } from '@colonist/utils';
export const UIGameBeginnerHint = ({ className })=>{
    const [isAnimationPlaying, setIsAnimationPlaying] = useState(true);
    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });
    const beginnerHintType = useGameStore((state)=>state.gameBeginnerHint.beginnerHintType);
    const myColor = useGameStore((state)=>state.myColor);
    const beginnerHintData = useGameStore((state)=>{
        var _state_gameBeginnerHint_beginnerHintData;
        return (_state_gameBeginnerHint_beginnerHintData = state.gameBeginnerHint.beginnerHintData) === null || _state_gameBeginnerHint_beginnerHintData === void 0 ? void 0 : _state_gameBeginnerHint_beginnerHintData.data;
    });
    const wantedResources = (beginnerHintData === null || beginnerHintData === void 0 ? void 0 : beginnerHintData.wantedResources) != null ? beginnerHintData === null || beginnerHintData === void 0 ? void 0 : beginnerHintData.wantedResources : [];
    const resourceName = wantedResources.length > 0 ? EnumUtils.getEnumKey(wantedResources[0], CardEnum) : '';
    const beginnerHintContent = useMemo(()=>getBeginnerHintContent(beginnerHintType, myColor, resourceName), [
        beginnerHintType,
        myColor,
        resourceName
    ]);
    const shouldShowBeginnerHint = beginnerHintType != undefined;
    const targetElement = beginnerHintContent ? document.getElementById(beginnerHintContent.elementId) : null;
    useEffect(()=>{
        if (beginnerHintContent != null && targetElement != null) {
            AudioManager.play(AudioType.BeginnerHintActivated);
        } else {
            setIsAnimationPlaying(true);
        }
    }, [
        beginnerHintContent
    ]);
    const setContainerPosition = ()=>{
        if (targetElement) {
            const { x, y, width } = targetElement.getBoundingClientRect();
            const positionX = x + width / 2;
            const positionY = y;
            setPosition({
                x: positionX,
                y: positionY
            });
        }
    };
    useEffect(()=>{
        setContainerPosition();
        window.addEventListener('resize', setContainerPosition);
        return ()=>{
            window.removeEventListener('resize', setContainerPosition);
        };
    }, [
        beginnerHintContent === null || beginnerHintContent === void 0 ? void 0 : beginnerHintContent.elementId
    ]);
    if (beginnerHintContent == null || targetElement == null || !shouldShowBeginnerHint) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(className, styles.container),
        style: {
            left: position.x,
            top: position.y
        }
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        position: "top",
        clickActionEnabled: true,
        content: /*#__PURE__*/ React.createElement("div", {
            className: styles.tooltipContent
        }, /*#__PURE__*/ React.createElement("img", {
            className: styles.hintTooltipIcon,
            src: beginnerHintContent.iconPath
        }), /*#__PURE__*/ React.createElement("div", {
            className: styles.hintTooltipText
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.hintTitle
        }, /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.beginnerTips.actionHints.title"
        })), /*#__PURE__*/ React.createElement("div", {
            className: styles.hintDescription
        }, /*#__PURE__*/ React.createElement(T, {
            id: beginnerHintContent.description
        })))),
        hoverActionEnabled: false,
        menuClassName: styles.hintTooltipMenu,
        onOpenChange: (tooltipOpen)=>setIsAnimationPlaying(!tooltipOpen)
    }, /*#__PURE__*/ React.createElement("img", {
        className: clsx(styles.icon, {
            [styles.hintAnimation]: isAnimationPlaying
        }),
        src: IconBeginnerHint
    })));
};
